/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductionRecord } from './productionRecord';
import { OrderItemConfigurationFormData } from './orderItemConfigurationFormData';
import { Change } from './change';
import { BatchComment } from './batchComment';


export interface OrderItemConfigurationDto { 
    id?: string;
    name?: string;
    amount?: number;
    status?: OrderItemConfigurationDto.StatusEnum;
    productionRecord?: ProductionRecord;
    configNo?: number;
    assemblerEmails?: Array<string>;
    dueDate?: string;
    ticketIds?: Array<number>;
    paymentAccountId?: number;
    productionStopped?: boolean;
    unconfirmedChanges?: Array<Change>;
    version?: number;
    cancellationConfirmed?: boolean;
    batchComments?: Array<BatchComment>;
    formData?: OrderItemConfigurationFormData;
}
export namespace OrderItemConfigurationDto {
    export const StatusEnum = {
        Incomplete: 'INCOMPLETE',
        Fulfilled: 'FULFILLED',
        ConfirmedBySales: 'CONFIRMED_BY_SALES',
        ReadyForProduction: 'READY_FOR_PRODUCTION',
        InProduction: 'IN_PRODUCTION',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        Canceled: 'CANCELED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


